import styles from './Todos.module.css';

const Loader = () => {
  return <div className={styles.loader}></div>;
};

export default Loader;
